<section class="bg-gray-50 dark:bg-gray-900">
    <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div
            class="w-full p-6 bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md dark:bg-gray-800 dark:border-gray-700 sm:p-8">
            <h2 class="mb-1 text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                Forgot Password
            </h2>
            <form [formGroup]="forgotPasswordForm" class="mt-4 space-y-4 lg:mt-5 md:space-y-5" (ngSubmit)="onSubmit()">

                <div>
                    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Email
                    </label>

                    <input type="email" id="email" formControlName="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg 
                   focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 
                   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
                   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                    <div *ngIf="submitted && form.email.errors">
                        <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                            Email is required
                        </p>
                        <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                            Invalid Email format
                        </p>
                    </div>
                </div>

                <div class="flex space-x-1">
                    <button type="submit" class="btn btn-secondary">
                        Send
                    </button>

                    <button type="button" (click)="backToLogin()"
                        class="text-[#3f3f47] text-sm bg-transparent border-none px-1 py-2 font-bold hover:underline focus:outline-none">
                        Back to Login
                    </button>
                </div>

            </form>
        </div>
    </div>
</section>